import { axios } from 'apis/axios'

export async function getAccessTokenFromResfreshToken(refresh_token?: string) {
    try {
        const refreshToken = refresh_token || localStorage.getItem('refresh_token');
        if (!refreshToken) return window.location.href = process.env.REACT_APP_LOGIN_URL ?? '/'

        const response: any = await axios.post('/oe/users/initiate-auth', { token: refreshToken });

        const { AccessToken } = response.data;

        localStorage.setItem('access_token', AccessToken);
        return AccessToken
    } catch (error) {
        window.location.href = process.env.REACT_APP_LOGIN_URL ?? '/'
        throw "Invalid refresh token"
    }
}